import React, { useEffect, useMemo, useRef, useState, useImperativeHandle, forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import styles from './index.module.less';
import { getSampleDraftTreeData, updateBatch, create, deleteRecord } from './../../service';
import { postRecordList } from './../../../filterTree/service';
import { debounce } from 'lodash';
import { AssetModuleTable } from '@/asset/AssetModuleTable';
import { Api as FetchAPI } from '@cui/req';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Table, Empty, Tabs, message, Input } from 'antd';

interface MaterialListTableProps {
  currentSelectNode: any;
  pageType: string;
  taskId?: string;
}

const MaterialListTable: ForwardRefExoticComponent<PropsWithoutRef<MaterialListTableProps> & RefAttributes<Record<any, any>>> = forwardRef((
  {
    currentSelectNode,
    pageType,
    taskId,
  },
  ref,
) => {
  const picTableRef = useRef<any>();
  const [mode, setMode] = useState<string>('view');
  const [valueLength, setValueLength] = useState<number>(0);

  const onMaterialSave = async () => {
    if (!currentSelectNode || mode === 'view') return;
    console.log('onMaterialSave-pic-material');
    const picList = picTableRef.current?.getRowsData();
    const picMateList = picList?.map((el: any) => {
      return {
        recordId: el.isc_npi_demand_design_material_delivery_bo_id || '0',
        values: {
          material_code: el.material_code || null,
          mirror_material_code: el.mirror_material_code || null,
          isc_npi_demand_design_material_delivery_bo_id: el.isc_npi_demand_design_material_delivery_bo_id || null,
        },
      };
    });
    const picUpdateList = picMateList?.filter((el: any) => el.recordId !== '0');
    const params = {
      appId: 'tp',
      modelId: 'isc_npi_demand_design_material_delivery_bo',
      data: picUpdateList?.map((el: any) => el.values) || [],
    };
    const res = await updateBatch(params);
  };
  useMemo(() => {
    let newMode = 'view';
    if (pageType !== 'view') {
      newMode = 'edit';
    }
    // 只有eimos可编辑
    if ((!currentSelectNode?.isHighlight && taskId !== 'npi_DA20230525143609176080349') || currentSelectNode?.data_source !== 'eimos') {
      newMode = 'view';
    }
    setMode(newMode);
  }, [currentSelectNode]);

  return (
    <AssetModuleTable
      API={{ FetchAPI }}
      moduleID={'isc_npi_demand_design_material_delivery_bo'}
      namespaceID="tp"
      columns={[
        { dataIndex: 'material_code', getRowConfig: () => ({ disabled: true }) },
        { dataIndex: 'mirror_material_code' },
      ]}
      search={false}
      tableBaseMode={mode}
      hidePagination={pageType !== 'view' ? true : undefined}
      headerTitle={'none'}
      requestParams={{
        filter: `(material_code = '${currentSelectNode?.id}' AND cparts_code = '${currentSelectNode?.cparts_code}')`,
        sort: 'created_at',
        incPageNavigation: true,
        incTotal: true,
        limit: 1000,
        page: 1,
        pageCursor: '',
        version: '0',
      }}
      ref={picTableRef}
      rowDelable={false}
      optionColumns={false}
      toolBarRender={undefined}
      onChange={(values: any) => {
        if (values.length === 0) return;
        if (values.length !== valueLength) {
          setValueLength(values.length);
        } else {
          debounce(onMaterialSave, 1000)();
        }
      }}
    />
  );
});

export default MaterialListTable;
